/** @format */

import React, { Fragment } from "react";
import { createRoot } from "react-dom/client";
import "./analytics";
import { unstable_HistoryRouter as HistoryRouter } from "react-router-dom";
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import { PersistGate } from "redux-persist/lib/integration/react";

import { Provider } from "react-redux";
import { ThemeProvider } from "@mui/material/styles";
import { history, store, persistor } from "./store/configureStore";
import Notifications from "src/utils/Notifications";
import I18N from "./i18n";
import routes from "src/routes";
import theme from "src/ui/library/theme";
import { v4 as uuidv4 } from "src/helpers/uuid";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { initVersionChecker } from "src/utils/versionChecker";

const nonce = uuidv4() && uuidv4().toString("base64");
const csp = `
default-src 'self';
script-src 'self' g.alicdn.com az416426.vo.msecnd.net 'strict-dynamic' 'nonce-${nonce}';
style-src 'self' 'nonce-${nonce}';
img-src 'self' data: *;
connect-src 'self' dc.services.visualstudio.com az416426.vo.msecnd.net *.ey.com dpm.demdex.net api.ipify.org;
frame-src *.powerbi.com;
`;
window.__webpack_nonce__ = nonce;
require("src/scss/index.scss");

const emotionCache = createCache({ key: "mui", nonce, prepend: true });

// attempt at addressing cache issue
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.ready.then((registration) => {
    registration.unregister();
  });
}
class App extends React.Component {
  componentDidMount() {
    // Initialize event-driven version checker for production only
    // No background polling - only checks on page load, focus, and visibility changes
    if (process.env.NODE_ENV === "production") {
      initVersionChecker();
    }
  }

  render() {
    return (
      <Fragment>
        <HelmetProvider>
          <Helmet>
            <meta httpEquiv="Content-Security-Policy" content={csp} />
            <meta property="csp-nonce" content={nonce} />
          </Helmet>
          <Provider store={store}>
            <PersistGate loading={<h1>loading</h1>} persistor={persistor}>
              <CacheProvider value={emotionCache}>
                <ThemeProvider theme={theme()}>
                  <I18N>
                    <Notifications>
                      <HistoryRouter history={history}>{routes}</HistoryRouter>
                    </Notifications>
                  </I18N>
                </ThemeProvider>
              </CacheProvider>
            </PersistGate>
          </Provider>
        </HelmetProvider>
      </Fragment>
    );
  }
}

createRoot(document.getElementById("root")).render(<App />);
